export default {
  "content": "<g clip-path=\"url(#a)\" fill=\"#3F4450\"><path d=\"M9.86 4.31l-7.71 7.73-.15.24-.98 3.22c-.1.32.15.56.47.47l3.22-.96c.09-.05.17-.11.26-.16l7.7-7.72c.19-.19.23-.48.07-.63L10.5 4.24c-.16-.15-.44-.12-.64.07zm5.55-2.73a1.98 1.98 0 00-2.81 0l-.69.69c-.16.16-.16.41 0 .56l2.25 2.25c.16.16.41.16.56 0l.69-.69c.78-.77.78-2.03 0-2.81z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(1 1)\" d=\"M0 0h15v14.99H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};